// uploadDocumentAPI.js
import API_BASE_URL, { API_BASE_URL_CRYS } from "../BaseURL/baseURL";

export async function fetchDeedBase64(pdeId) {
  const res = await fetch(
    `${API_BASE_URL}/UploadDoc/GetBase64PDF?pde_id=${pdeId}`,
    { headers: { "Content-Type": "application/json" } }
  );
  if (!res.ok) throw new Error("Failed to fetch deed PDF");
  const data = await res.json();
  return data.base64;
}

// export async function uploadDocuments(formData, isPOA = false) {
//   ;
//   const endpoint = isPOA
//     ? "/UploadDoc/UploadDocuments_POA"
//     : "/uploadDoc/UploadDocuments_all";
//   const res = await fetch(`${API_BASE_URL_CRYS}${endpoint}`, {
//     method: "POST",
//     body: formData,
//   });
//   if (!res.ok) {
//     const text = await res.text();
//     throw new Error(`Upload failed: ${text}`);
//   }
// }

export async function uploadDocuments(
  formData,
  isPOA = false,
  isOther = false
) {
  let endpoint;
  if (isPOA) {
    endpoint = "/UploadDoc/UploadDocuments_POA";
  } else if (isOther) {
    endpoint = "/UploadDoc/UploadDocuments_Agree_Release";
  } else {
    endpoint = "/uploadDoc/UploadDocuments_all";
  }
  const res = await fetch(`${API_BASE_URL_CRYS}${endpoint}`, {
    method: "POST",
    body: formData,
  });
  if (!res.ok) {
    const text = await res.text();
    throw new Error(`Upload failed: ${text}`);
  }
}

export async function fetchUploadedDocDetails(pdeId) {
  const res = await fetch(
    `${API_BASE_URL_CRYS}/UploadDoc/GetDocumentDetails?pde_id=${pdeId}`
  );
  if (!res.ok) throw new Error("Failed to load document details");
  return await res.json();
}
